import { render } from "./inventoryInit.vue?vue&type=template&id=1b7921d7&scoped=true"
import script from "./inventoryInit.vue?vue&type=script&lang=js"
export * from "./inventoryInit.vue?vue&type=script&lang=js"

import "./inventoryInit.vue?vue&type=style&index=0&id=1b7921d7&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7921d7"]])

export default __exports__